export default "__VITE_PUBLIC_ASSET__cce36a81__"